export default __webpack_public_path__ + "static/media/Headlands-Frame.6bd61abb.jpg";